import { ChevronRight } from "@mui/icons-material";
import { Divider, List, ListItem, ListItemButton, ListItemText } from "@mui/material";
import { Fragment } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

import { GqlPlannerV2VisitPlannedOnDate } from "~/__generated__";
import { parseStringToDate } from "~/modules/app/util/dateHelpers";
import { formatDate } from "~/modules/app/util/formatters";

interface VisitPlannedOnDatesPanelProps {
    currentDate: Date;
    elements: GqlPlannerV2VisitPlannedOnDate[];
    isOnPriorDate: boolean;
    isReplannable: boolean;
    onClick: (date: Date) => void;
    onReplanClick: () => void;
}

export function VisitPlannedOnDatesPanel({
    currentDate,
    elements,
    isOnPriorDate,
    isReplannable,
    onClick,
    onReplanClick,
}: VisitPlannedOnDatesPanelProps) {
    const { t } = useTranslation("plannerV2");

    return (
        <List>
            {elements.map((element, index) => {
                const date = parseStringToDate(element.date);

                const isLast = index === elements.length - 1;
                const disabled = isReplannable || !isLast;
                const secondaryAction = !disabled ? <ChevronRight /> : null;

                return (
                    <Fragment key={element.date}>
                        <ListItem disablePadding secondaryAction={secondaryAction}>
                            <ListItemButton disabled={isReplannable || !isLast} onClick={() => onClick(date)}>
                                <ListItemText>
                                    {isReplannable || !isLast
                                        ? t("visitPlannedOnDates.cancelledOn", {
                                              date: formatDate(date, "medium"),
                                              carpools: element.numberOfPlannerTravelGroups,
                                          })
                                        : t("visitPlannedOnDates.plannedOn", {
                                              date: formatDate(date, "medium"),
                                              carpools: element.numberOfPlannerTravelGroups,
                                          })}
                                </ListItemText>
                            </ListItemButton>
                        </ListItem>

                        {isReplannable && !isOnPriorDate && <Divider />}
                    </Fragment>
                );
            })}

            {isReplannable && !isOnPriorDate && (
                <ListItem disablePadding secondaryAction={<ChevronRight />}>
                    <ListItemButton onClick={() => onReplanClick()}>
                        <ListItemText>
                            {t("visitPlannedOnDates.replanOn", {
                                date: formatDate(currentDate, "medium"),
                            })}
                        </ListItemText>
                    </ListItemButton>
                </ListItem>
            )}
        </List>
    );
}
